import { ExclamationCircle, GeoAlt, Search } from "react-bootstrap-icons";
import PopupWrapper from "../../components/PopupWrapper";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { findPropertySchema } from "./VerificationFormHelpers";
import axios from "axios";
import urls from "../../Utils/urls";
import { oracleConfig } from "../../Utils/constant";
import { SelectField } from "./VOMStepperForm";
import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "../../Utils/CustomComponent";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";

const PropertyAddressModal = ({
  show,
  setShow,
  states,
  selectedProperty,
  setSelectedProperty,
  noPropertyFound,
  setNoPropertyFound,
  setValueInMainForm,
  setValidLoanNumber,
  source = "VOM",
  validateBorrower = () => {},
  validateLender = () => {},
  requestor_type = null,
}) => {
  const [submitLoading, setSubmitLoading] = useState(false);
  const [properties, setProperties] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [propertySelectedByRadio, setPropertySelectedByRadio] = useState(null);
  const [noPropertyFoundFlag, setNoPropertyFoundFlag] = useState(false);
  // const [borrowerEmailAlert, setBorrowerEmailAlert] = useState(null);
  const [emailLoader, setEmailLoader] = useState(false);
  const { email } = useParams();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    reset,
    trigger,
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(findPropertySchema(noPropertyFoundFlag)),
  });
  // const borrower_email = watch("borrower_email");
  // const remarks = watch("remarks");

  async function onSubmit(payload) {
    const isValid = await trigger(["street", "state", "zipcode"]);
    if (!isValid) return;
    setSubmitLoading(true);
    try {
      const res = await axios.post(
        urls.VOM.findPropertyAddress,
        payload,
        oracleConfig,
      );
      const data = res?.data?.response ? JSON.parse(res.data.response) : null;
      if (!data?.properties?.length) {
        setValueInMainForm("property_street", payload?.street);
        setValueInMainForm("property_city", payload?.city);
        setValueInMainForm("property_state", payload?.state);
        setValueInMainForm("property_zip", payload?.zipcode);
        setNoPropertyFound(true);
        setNoPropertyFoundFlag(true);
        setProperties([]);
      } else {
        setNoPropertyFound(false);
        setNoPropertyFoundFlag(false);
        setProperties(data?.properties);
      }
    } catch (error) {
      console.error(error);
      setProperties([]);
    } finally {
      setSubmitLoading(false);
    }
  }

  function handleSelection() {
    setSelectedProperty(propertySelectedByRadio);
    setValidLoanNumber(propertySelectedByRadio?.ACCOUNT);
    if (source === "payoff" && requestor_type === "Borrower") {
      validateBorrower(
        propertySelectedByRadio?.LOANRECID,
        propertySelectedByRadio?.ACCOUNT,
        "property",
      );
    } else if (source === "payoff" && requestor_type === "Lender") {
      validateLender(
        propertySelectedByRadio?.LOANRECID,
        propertySelectedByRadio?.ACCOUNT,
        "property",
      );
    }
    handleClose();
  }

  // async function validateBorrowerEmail() {
  //   setEmailLoader(true);
  //   try {
  //     const res = await axios.post(
  //       urls.VOM.validateBorrowerEmail,
  //       {
  //         borrower_email: borrower_email,
  //       },
  //       oracleConfig,
  //     );

  //     const response = res?.data?.response
  //       ? JSON.parse(res?.data?.response)
  //       : null;
  //     // console.log({response})

  //     if (response?.message === "Borrower is exist.") {
  //       setBorrowerEmailAlert(null);
  //       setValueInMainForm("borrower_email", borrower_email);
  //       setValueInMainForm("remarks", remarks);
  //       handleClose();
  //     } else {
  //       setBorrowerEmailAlert("This email address is not registered with us.");
  //       setValueInMainForm("borrower_email", null);
  //       setValueInMainForm("remarks", null);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     setBorrowerEmailAlert("This email address is not registered with us.");
  //   } finally {
  //     setEmailLoader(false);
  //   }
  // }

  async function handleTicketCreation(data) {
    setEmailLoader(true);
    const id = toast.loading("Creating a new ticket");
    const { street, city, state, zipcode } = data;
    try {
      const payload = {
        contact_email: email,
        status_id: "1",
        severity_id: "4",
        urgency_id: "1",
        department_id: "1",
        category_id: "97547428750582142103564002548773457410",
        subject:
          "Verification of Mortgage Request – Property Address Not Found",
        incident_description: `The property search did not return any matching results for the following address details entered by the user:

        Street: ${street}
        City: ${city}
        State: ${state}
        Zip Code: ${zipcode}

        The user has created this ticket to proceed with the request.
        Please review the property details and follow up as required.`,
      };

      const res = await axios.post(
        urls.support.postTicket(),
        payload,
        oracleConfig,
      );
      const ticket_number = res?.data?.incident_number;
      toast.update(id, {
        render: `Ticket Created: ${ticket_number}`,
        type: "success",
        isLoading: false,
        ...commonToast,
      });

      navigate("/thankyou", {
        state: {
          text: `Thanks for submitting your Verification of Mortgage (VOM) request.
          We couldn’t automatically locate the property using the address you provided, so a support ticket has 
          been created for manual review. Our team will verify the details and continue processing your 
          mortgage verification.
          `,
          showBtn: false,
        },
      });
    } catch (error) {
      console.error(error);
      toast.update(id, {
        render: "SOME ERROR OCCURED",
        type: "error",
        isLoading: false,
        ...commonToast,
      });
    } finally {
      setEmailLoader(false);
    }
  }

  function handleClose() {
    setProperties([]);
    setNoPropertyFoundFlag(false);
    reset({
      street: null,
      city: null,
      state: null,
      zipcode: null,
      borrower_email: null,
      remarks: null,
    });
    setShow(false);
  }

  return (
    <PopupWrapper
      title={
        <h4 className="p-4 font-weight-bold text-dark d-flex align-items-center fw-bold">
          <GeoAlt className="me-4" color="var(--primary-color)" />
          Search Property Address
        </h4>
      }
      extraClass={"width-900"}
      Component={
        <div className="row text-start px-5">
          <div className="row text-start px-5 pt-5 pb-3 no-property-card">
            <div className="vf-group col-12">
              <label>Property Address - Street</label>
              <input
                {...register("street")}
                className={errors.street ? "vf-input error" : "vf-input"}
                placeholder="123 Main Street"
                autoFocus
              />
              {errors.street && (
                <small className="text-error">{errors.street.message}</small>
              )}
            </div>
            <div className="vf-group col-4">
              <label>City</label>
              <input
                {...register("city")}
                className={errors.city ? "vf-input error" : "vf-input"}
                placeholder="Los Angeles"
              />
            </div>
            <div className="vf-group col-4">
              <SelectField
                label={"State"}
                field={"state"}
                placeholder={"Select..."}
                options={states}
                watch={watch}
                setValue={setValue}
              />
              {errors.state && (
                <small className="text-error mt-5">
                  {errors.state.message}
                </small>
              )}
            </div>
            <div className="vf-group col-4">
              <label>Zip Code</label>
              <input
                {...register("zipcode")}
                className={errors.zipcode ? "vf-input error" : "vf-input"}
                placeholder="90001"
              />
              {errors.zipcode && (
                <small className="text-error">{errors.zipcode.message}</small>
              )}
            </div>

            <div className="vf-group col-12">
              <LoadingButton
                type="submit"
                className="btn btn-primary btn-md py-4 btn-modern-outline"
                title={
                  <span>
                    <Search className="me-4" />
                    Find Property
                  </span>
                }
                disabled={submitLoading}
                loading={submitLoading}
                onClick={() => onSubmit(watch())}
              />
            </div>
          </div>

          {properties?.length ? (
            <PropertySelection
              properties={properties}
              selectedId={selectedId}
              setSelectedId={setSelectedId}
              onSelect={setPropertySelectedByRadio}
            />
          ) : null}

          {noPropertyFoundFlag ? (
            <NoPropertyFoundForm
            // register={register}
            // errors={errors}
            // borrowerEmailAlert={borrowerEmailAlert}
            />
          ) : null}

          <div className="d-flex justify-content-end mt-5 gap-4">
            <button
              type="button"
              className="btn btn-secondary me-3 border btn-modern-outline py-4 px-5"
              onClick={handleClose}
            >
              Cancel
            </button>
            {properties?.length ? (
              <button
                type="submit"
                className="btn btn-primary text-white btn-modern-outline px-5 py-4"
                onClick={handleSelection}
                disabled={!selectedId}
              >
                Select & Continue
              </button>
            ) : null}
            {noPropertyFoundFlag ? (
              <LoadingButton
                type="submit"
                className="btn btn-primary text-white btn-modern-outline px-5 py-4"
                title={"Create Ticket"}
                disabled={emailLoader}
                loading={emailLoader}
                onClick={handleSubmit(handleTicketCreation)}
              />
            ) : null}
          </div>
        </div>
      }
      toShow={show}
      closeEventHandler={handleClose}
    />
  );
};

export default PropertyAddressModal;

const PropertySelection = ({
  properties = [],
  onSelect,
  selectedId,
  setSelectedId,
}) => {
  const handleSelect = (property) => {
    setSelectedId(property.PROPERTY_ID);
    onSelect?.(property);
  };

  return (
    <div className="property-select-wrapper">
      <h3 className="property-select-title">
        Select a Property ({properties.length} found)
      </h3>

      <div className="property-list">
        {properties.map((property) => (
          <label
            key={property?.PROPERTY_ID}
            className={`property-card ${
              selectedId === property.PROPERTY_ID ? "active" : ""
            }`}
          >
            <input
              type="radio"
              name="selectedProperty"
              checked={selectedId === property.PROPERTY_ID}
              onChange={() => handleSelect(property)}
            />

            <div className="property-content">
              <div className="property-address">{property.STREET}</div>

              <div className="property-city">
                {property.CITY}, {property.STATE} {property.ZIPCODE}
              </div>

              <div className="property-tags">
                <span className="tag">
                  Borrower: {property.MASKED_FULLNAME}
                </span>
                <span className="tag">Loan #: {property.MASKED_ACCOUNT}</span>
              </div>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
};

const NoPropertyFoundForm = ({ register, errors = {}, borrowerEmailAlert }) => {
  return (
    <div className="no-property-wrapper" style={{ marginTop: "1.5rem" }}>
      {/* ALERT */}
      <div className="no-property-alert">
        <div className="alert-icon">
          <ExclamationCircle size={22} />
        </div>

        <div>
          <h4>No Property Found</h4>
          {/* <p>
            We couldn't find a matching property. Please provide the borrower's
            contact details and remarks to proceed.
          </p> */}
          <p>
            We couldn't find a matching property. Click "Create Ticket" to
            proceed and our team will follow up.
          </p>
        </div>
      </div>

      {/* FORM CARD */}
      {/* <div className="no-property-card">
        <div className="form-group-custom">
          <label>
            Borrower Email Address <span className="required">*</span>
          </label>
          <input
            type="email"
            placeholder="borrower@email.com"
            {...register("borrower_email")}
            className={errors.borrower_email ? "input error" : "input"}
          />
          {(errors?.borrower_email || borrowerEmailAlert) && (
            <small className="error-text">
              {errors?.borrower_email?.message ?? borrowerEmailAlert}
            </small>
          )}
        </div>

        <div className="form-group-custom">
          <label>Remarks</label>
          <textarea
            rows={3}
            className="textarea"
            placeholder="Enter remarks explaining why the property was not found..."
            {...register("remarks")}
          />
        </div>
      </div> */}
    </div>
  );
};
